import noop from 'lodash/noop';
import { call, delay, put, takeEvery, takeLatest } from 'redux-saga/effects';

import type { ChatWidgetAction } from '../actions/chatWidgets';
import * as api from '../api/chatWidgets';

function* createWidgetGen(action) {
  try {
    const result = yield call(api.createWidget, action.widget);

    const succeededAction: ChatWidgetAction = {
      type: 'CHAT_CREATE_WIDGET_SUCCEEDED',
      localWidget: action.widget,
      widget: result.data,
    };

    const dataForChatFlow = Object.assign(action, result.data);

    //console.warn('dataForChatFlow', dataForChatFlow);

    const afterCreationAction = {
      type: 'CHAT_FLOW_ADD_AFTER_CHAT_WIDGET_CREATED',
      payload: {
        result: {
          data: dataForChatFlow,
        },
      },
    };

    //console.warn('chatFlowAddAfterChatWidgetCreated', result.data);

    yield put(succeededAction);
    yield put(afterCreationAction);

    yield delay(2000);

    yield put({
      type: 'CHAT_FLOWS_GET_ALL',
      meta: { reject: noop, resolve: noop },
    }); // refetch the widgets.
  } catch (e: any) {
    const failedAction: ChatWidgetAction = {
      type: 'CHAT_CREATE_WIDGET_FAILED',
      widget: action.widget,
      error: e.message,
    };

    yield put(failedAction);
  }
}

function* readWidgetsGen(action: any) {
  try {
    const result = yield call(api.readWidgets, action.payload);

    const succeededAction: ChatWidgetAction = {
      type: 'CHAT_READ_WIDGETS_SUCCEEDED',
      widgets:
        result && result.data && Array.isArray(result.data.widgets)
          ? result.data.widgets
          : [],
      meta: result && result.meta ? result.meta : {},
    };

    yield put(succeededAction);
  } catch (e: any) {
    const failedAction: ChatWidgetAction = {
      type: 'CHAT_READ_WIDGETS_FAILED',
      error: e.message,
    };

    yield put(failedAction);
  }
}

function* readWidgetGen(action: any) {
  try {
    const result = yield call(api.readWidget, action.widgetId);
    const succeededAction: ChatWidgetAction = {
      type: 'CHAT_READ_WIDGET_SUCCEEDED',
      widget: result.data,
    };

    yield put(succeededAction);
  } catch (e: any) {
    const failedAction: ChatWidgetAction = {
      type: 'CHAT_READ_WIDGET_FAILED',
      error: e.message,
    };

    yield put(failedAction);
  }
}

function* updateWidgetGen(action: any) {
  try {
    yield call(api.updateWidget, action.data, action.id);

    const succeededAction: ChatWidgetAction = {
      type: 'CHAT_UPDATE_WIDGET_SUCCEEDED',
      widget: action.data,
      widgetId: action.id,
    };

    yield put(succeededAction);
  } catch (e: any) {
    const failedAction: ChatWidgetAction = {
      type: 'CHAT_UPDATE_WIDGET_FAILED',
      error: e.message,
    };

    yield put(failedAction);
  }
}

function* deleteWidgetGen(action: any) {
  try {
    yield call(api.deleteWidget, action.widget);

    const succeededAction: ChatWidgetAction = {
      type: 'CHAT_DELETE_WIDGET_SUCCEEDED',
      widget: action.widget,
    };

    yield put(succeededAction);
  } catch (e: any) {
    const failedAction: ChatWidgetAction = {
      type: 'CHAT_DELETE_WIDGET_FAILED',
      error: e.message,
      index: action.index,
      widget: action.widget,
    };

    yield put(failedAction);
  }
}

export const chatWidgets = [
  takeEvery('CHAT_CREATE_WIDGET', createWidgetGen),
  takeLatest('CHAT_READ_WIDGETS', readWidgetsGen),
  takeEvery('CHAT_READ_WIDGET', readWidgetGen),
  takeEvery('CHAT_UPDATE_WIDGET', updateWidgetGen),
  takeEvery('CHAT_DELETE_WIDGET', deleteWidgetGen),
];
